import React, { useEffect, useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import {
  communityPathForStatus,
  fetchCommunityMembershipStatus,
  type CommunityMembershipStatus,
} from '../../services/communityMembershipService';
import '../Community/CommunityForum.css';

type Props = {
  children: React.ReactNode;
};

export default function CommunityAccessGate({ children }: Props) {
  const { user, loading: authLoading } = useAuth();
  const [status, setStatus] = useState<CommunityMembershipStatus | null>(null);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (authLoading) return;
    if (!user) {
      setChecked(true);
      return;
    }

    let cancelled = false;
    (async () => {
      const state = await fetchCommunityMembershipStatus();
      if (cancelled) return;
      setStatus(state?.status ?? 'none');
      setChecked(true);
    })();

    return () => {
      cancelled = true;
    };
  }, [authLoading, user]);

  if (authLoading || !checked) {
    return (
      <div className="dcf-page dcf-page--loading" style={{ alignItems: 'center', justifyContent: 'center' }}>
        <p className="text-sm text-slate-500">Загрузка сообщества…</p>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="dcf-auth-gate">
        <h1 className="text-lg font-semibold text-slate-900">Сообщество datacircle</h1>
        <p className="mt-3 text-sm text-slate-600">
          Войдите в аккаунт, чтобы участвовать в обсуждениях и задавать вопросы участникам рынка.
        </p>
        <Link to="/" className="dcf-btn dcf-btn--primary mt-6 inline-flex">
          На главную
        </Link>
      </div>
    );
  }

  if (status === 'pending') {
    return <Navigate to={communityPathForStatus('pending')} replace />;
  }

  if (status === 'none' || status === 'rejected') {
    return <Navigate to="/private-circle#application" replace />;
  }

  if (status !== 'approved') {
    return <Navigate to="/private-circle/enter" replace />;
  }

  return <>{children}</>;
}
